import type { IconProps } from '../types/IconProps.ts';
export const Navigation2: IconProps = {
    name: 'Navigation2',
    children: [
        `<path d="M11.98 2.04h.04l7.96 18.92q0 .03-.02.02l-7.6-2.85a1 1 0 0 0-.71 0l-7.6 2.85a.02.02 0 0 1-.03-.02z" />`,
    ]
};